export default "__VITE_ASSET__58704e58__"